













































import { Prop, Vue, Component } from 'vue-property-decorator';

@Component
export default class MessageCreationInfo extends Vue {
  public messageInfoModal = false;

  @Prop({
    default: () => [],
  })
  public variables: any;

  public showMessageInfoModal(): void {
    this.messageInfoModal = true;
  }
  public closeMessageInfoModal(): void {
    this.messageInfoModal = false;
  }
}
